import React from 'react';
import moment from 'moment';
import 'moment/locale/es';
import './Entrega.scss';

const Entrega = ({ color }) => {
  if (!color?.fechaArribo) {
    return null;
  }

  const today = moment(new Date());
  const current = new moment(color?.fechaArribo, 'YYYY-MM-DD HH:mm:ss');

  return (
    <div className="entrega">
      
        <span className="left"><b>ENTREGA</b></span>
        <span className="right">
          <b>
          {current > today ? (
            `${current.date()}/${current.month() + 1}/${current.year()}`
          ): (
            'INMEDIATA'
          )}
          </b>
          </span>
    </div>

  );
};

export default Entrega;